import { createActionTypeModel } from "../../global/action-model";

export const DtGPTChats = createActionTypeModel("DtGPTChats");
export const DtGPTChat = createActionTypeModel("DtGPTChat");

export const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE';
export const SET_SEND_CHAT_MESSAGE_LOADING = 'SET_SEND_CHAT_MESSAGE_LOADING';
export const SEND_CHAT_MESSAGE_NEW = 'SEND_CHAT_MESSAGE_NEW';
export const CLICK_NEW_MESSAGE = 'CLICK_NEW_MESSAGE';
export const SET_CHAT_MESSAGES = 'SET_CHAT_MESSAGES';

export const DtGPTConversations = createActionTypeModel("DtGPTConversations");